module.exports = __webpack_public_path__ + "static/media/email.8a5c9935.svg";